import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-slate-100 px-5 py-12 sm:py-16" data-id="element-32" data-mp="1blk9oxqpn104">
      <div className="mx-auto max-w-[680px]" data-id="element-33" data-mp="1gjlov7l0mg6b">
        <h2 className="text-center text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-34" data-mp="1gkeqxv914hi4">
          Frequently asked questions
        </h2>

        <div className="mt-7 space-y-2.5" data-id="element-35" data-mp="289qa18gln78l">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="rounded-lg border border-slate-200 bg-white" data-id="element-36" data-mp="1uhk1a7fs02j6" data-mpi={index}>
                <h3 data-id="element-37" data-mp="2n70tb3zhhhev">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left text-[0.95rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 transition-colors duration-150 ease-out hover:text-orange-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-700 sm:text-[1rem]" data-id="element-38" data-mp="2n6hcxrphf12y">
                    {faq.question}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-orange-700 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-39" data-mp="1ohq7hldafz7l" />
                  </button>
                </h3>
                {isOpen && <div className="space-y-2 border-t border-slate-200 px-5 py-4" data-id="element-40" data-mp="35584d70ltwy">
                    {faq.answer.map(paragraph => <p key={paragraph} className="text-[1rem] leading-relaxed text-slate-950" data-id="element-41" data-mp="3ue2hib6qpe7k">
                        {paragraph}
                      </p>)}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}